import SwipeableViews from "react-swipeable-views";

export const Carousel = SwipeableViews;

export default Carousel;
